var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-mapbox',{ref:"map",attrs:{"access-token":_vm.token,"map-style":"mapbox://styles/mapbox/streets-v11","center":_vm.center,"zoom":14,"id":"map"}},[_c('v-mapbox-navigation-control')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }